import { createFileRoute } from '@tanstack/react-router';
import { HelpSupportPage } from '@pages/help-support';

export const Route = createFileRoute('/_authenticated/help-support')({
  staticData: { hideRail: true },
  component: HelpSupportPage,
});
